import getDCHMessageType from '../../helpers/getDCHMessageType';
import { PAGE_FUNCTION, PAGE_NAME, SUB_FUNCTION } from '../../const/analytics';
import { AUTOPAY_SUCCESS_TYPE_NAMES } from '../../const/machines';
import { paymentTypes } from '../../const/paymentOptions';
import { getAnalyticsMessageType, getPaymentFlowFormValues } from '../helpers';
/* eslint-disable import/prefer-default-export */
const getPageNameForSuccess = (paymentMethod) => {
    const { CHECKING, SAVINGS, DEBIT, CREDIT } = PAGE_NAME.AUTOPAY.COMPLETE;
    if (paymentMethod.paymentMedium === 'PINLESS_DEBIT_CARD')
        return DEBIT;
    if (paymentMethod.paymentMedium === 'CREDIT_CARD')
        return CREDIT;
    if (paymentMethod.type === 'CHECKING')
        return CHECKING;
    return SAVINGS;
};
export const submitSuccessAnalyticsHandler = (context) => {
    var _a;
    const { successType, apiMachineRef } = context;
    const { featureFlags } = apiMachineRef.getSnapshot().context;
    const isUnenrolling = successType === AUTOPAY_SUCCESS_TYPE_NAMES.UNENROLLING;
    const isEnrolling = successType === AUTOPAY_SUCCESS_TYPE_NAMES.ENROLLING;
    const eventOptions = {
        pageFunction: PAGE_FUNCTION.MAKE_PAYMENT.AUTOPAY
    };
    const messageTypeDCH = getDCHMessageType(featureFlags.isDigitalCollectionsEnabled, (_a = apiMachineRef.getSnapshot().context.accountSummaryQueryResult) === null || _a === void 0 ? void 0 : _a.data);
    if (isUnenrolling) {
        return Object.assign(Object.assign(Object.assign({}, eventOptions), { pageName: PAGE_NAME.COMPLETE, pageSubFunction: SUB_FUNCTION.AUTOPAY.TURN_OFF_AUTOPAY }), (messageTypeDCH && { messageType: messageTypeDCH }));
    }
    const [paymentOption, paymentMethod] = getPaymentFlowFormValues(context);
    if (isEnrolling) {
        const messageType = getAnalyticsMessageType(context.apiMachineRef, paymentTypes.AUTOPAY, paymentOption);
        return Object.assign(Object.assign(Object.assign({}, eventOptions), { message: paymentOption, pageName: getPageNameForSuccess(paymentMethod), pageSubFunction: SUB_FUNCTION.AUTOPAY.ENROLL }), (messageType && { messageType }));
    }
    // autopay edit
    return Object.assign(Object.assign(Object.assign({}, eventOptions), { message: paymentOption, pageName: getPageNameForSuccess(paymentMethod), pageSubFunction: SUB_FUNCTION.AUTOPAY.EDIT }), (messageTypeDCH && { messageType: messageTypeDCH }));
};
